import { baseUrl, httpDelete, httpGet, httpPost, httpPut } from '@pressreader/services';

// Legacy default-import shape of the http adapter. Prefer importing from @pressreader/services directly.
export default { baseUrl, get: httpGet, post: httpPost, put: httpPut, delete: httpDelete };
